import {
  ComponentStyleProps,
  componentStylePropsOf,
} from "../../../../lib/styles/props/component-style-props";
import {
  ComponentMultiStyleConfig,
  Input,
  useMultiStyleConfig,
} from "@chakra-ui/react";
import React, { useState } from "react";
import { CMFrameButtonPopupSearchCondition } from "../CMFrameButtonPopupSearchCondition/CMFrameButtonPopupSearchCondition";

export type CMButtonPopupSearchConditionTextProps = {
  /**
   * プレースホルダーの文字
   */
  placeholder: string;

  /**
   * 入力可能な最大文字数。
   */
  maxLength?: number;

  /**
   * 確定ボタンのラベル
   */
  labelSubmit?: string;

  /**
   * クリアボタンのラベル
   */
  labelClear?: string;

  /**
   * クリアボタンの表示制御
   */
  hideClearButton: boolean;

  internalValue: string;
  onChangeInternalValue: (value: string) => void;

  onSubmit: () => void;
  onClear: () => void;
} & ComponentStyleProps;

/**
 * フリーテキスト検索条件を表示するコンポーネント
 */
export const CMButtonPopupSearchConditionText = ({
  placeholder,

  maxLength = 100,

  labelSubmit = "",
  labelClear = "",
  hideClearButton = false,

  internalValue,
  onChangeInternalValue,

  onSubmit,
  onClear,

  sx,

  ...rest
}: CMButtonPopupSearchConditionTextProps) => {
  const styles = useMultiStyleConfig("CMButtonPopupSearchConditionTextStyles");

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChangeInternalValue(e.target.value);
  };

  // 日本語入力中はエンターでsubmitしないようにするため。参考: https://www.gaji.jp/blog/2022/04/01/9405/
  const [composing, setComposing] = useState(false);
  const onKeydown = (key: string) => {
    if (key === "Enter" && !composing) onSubmit();
  };

  return (
    <CMFrameButtonPopupSearchCondition
      labelSubmit={labelSubmit}
      labelClear={labelClear}
      onSubmit={onSubmit}
      onClear={onClear}
      hideClearButton={hideClearButton}
      {...rest}
      sx={{ ...styles.container, ...sx }}
    >
      <Input
        placeholder={placeholder}
        value={internalValue}
        maxLength={maxLength}
        onChange={handleChange}
        onCompositionStart={() => setComposing(true)}
        onCompositionEnd={() => setComposing(false)}
        onKeyDown={(e) => onKeydown(e.key)}
        sx={styles.input}
        {...rest}
      />
    </CMFrameButtonPopupSearchCondition>
  );
};

export const CMButtonPopupSearchConditionTextStyles: ComponentMultiStyleConfig =
  {
    parts: ["container", "input"],
    baseStyle: {
      container: {},
      input: {},
    },
  };
